import script from "./[market].vue?vue&type=script&lang=ts&setup=true"
export * from "./[market].vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__